<template>
    <div class="all clearfix">
        <Myleft ref="left"></Myleft>
        <div class="mdCont fl bgff w1070 ml10">
           <div class="grid pb30">
                <div class="screen mt5">
                    <div class="item clearfix"> 
                        <div class="zu corm fl">
                            <span class="element" :class="{'curr':curRank==index,'disabled':curMedia=='抖音' && item!=2}" v-for="(item,index) in rankList" @click="dropDownChoose(index,item,1);" :key="index">{{index}}</span> 
                        </div>
                       <!--  <span class="zu clearfix">
                            <span class="drop-down">
                                <button class="btn">{{curRank}}<i class="icons fr"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in rankList" @click="dropDownChoose(index,item,1);" :key="index">{{index}}</li>
                                </ul>
                            </span>
                        </span> -->
                        <span class="zu clearfix" v-if="curRankType!=1">
                            <span class="name">平台</span>
                            <span class="drop-down">
                                <button class="btn">{{curMedia}}<i class="icons fr"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in mediaList" @click="dropDownChoose(index,item,3);" :key="index">{{index}}</li>
                                </ul>
                            </span>
                        </span>
                        <span class="zu clearfix">
                            <span class="drop-down">
                                <button class="btn">{{curEmotion}}<i class="icons fr"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in motionList" @click="dropDownChoose(index,item,4);" :key="index">{{item}}</li>
                                </ul>
                            </span>
                        </span>
                        <span class="zu clearfix">
                            <span class="name">地区</span>
                            <city @cityCallback="citySelect1" ref="citySelect"></city>
                        </span>
                        <span class="zu yujin-text clearfix">
                            <span class="name">时间</span>
                            <span class="drop-down w140">
                                <vue-datepicker-local v-model="time" format="YYYY-MM-DD" :disabled-date="disabledDate" @input="changeTime"/>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="warp mt5 clearfix">
                    <div class="warp-body mh270 clearfix">
                        <div class="w541 fl">
                            <div class="echart-warp h545">
                                <div class="no-data pt40" v-if="nodata.mapChartData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                                 <mapChart id="mapEchart" :dataArray="mapChartData" :areaName="curMapName" v-if="mapChartData != ''" :isShowTit='showTit'></mapChart>
                            </div>
                        </div>    
                        <div class="w362 mt10 fr">
                            <div class="grid-header clearfix">
                                <h2 class="title fl">{{curRank}}事件TOP10</h2>
                                <!-- <div class="gridHeader-r fr">
                                    <span>热度值</span> 
                                    <div class="grid-info"><i class="icons icon-ask"></i> <p class="grid-tip r">根据转载传播计算的热度值</p></div>
                                </div> -->
                            </div>
                            <div class="no-data pt40" v-if="nodata.hotAllRank"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                            <ul class="news mt10">
                                <li v-for="(item,index) in hotAllRank" :key="index">
                                    <router-link class="cr3d" :to="{path:'newsDetails',query:{id:item.id,newsType:mediaList[curMedia],type:curRankType,api_secret:apiSecret}}" target="_blank">
                                        <span class="title ovhidden fl" :title="item.news_title"><i class="order">{{index+1}}</i>{{item.news_title}}</span>
                                        <strong class="data-num fr">{{item.exponent}}</strong>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mapChart from '../../components/echart/mapChart'
import Myleft from '../../components/left'
import city from '../../components/city.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    components: {mapChart,Myleft,VueDatepickerLocal,city},
    data() {
        return {
            apiSecret : this.$route.query.api_secret,
            hotTopicsList:[],
            showTit:true,
            defaultImg:'this.src="static/images/default.png"',
            tags:'全部',
            curRank:'七日热点',
            curRankType:7,
            rankList:{'昨日热点':2,'三日热点':3,'七日热点':7},
            curMedia:'全部',//当前媒体
            mediaList:{'全部':4,'网页':1,'微信':2,'微博':3,'头条':5,'抖音':6},//媒体下拉列表
            curEmotion:'全部',
            motionList:['全部','正面','中性','负面'],
            curCity:'全国',
            tagsList:[],
            mapChartData:[],//地图数据
            hotAllRank:[], //热点事件
            provinceList:[],//地图省份选择列表
            provinceFullList:[],//地图省份选择列表全称
            curMapName:'全国',//
            curFullName:'全国',//
            curProvMapName:'',//省
            curCityMapName:'',//市
            curAreaMapName:'',//县区
            pageCur:1,
            pageNum:10,
            dataCount:0,
            timeRange: [],
            time: new Date(),  //时间选择
            maxTime:new Date(),
            setTimer:null, //定时器
            province:'',//省份
            city:'',//城市
            county:'',//区县
            isShowMore:false,
            isShowEnd:false,
            nodata:{
                mornData:false,
                evenData:false,
                mapChartData:false,
                hotAllRank:false
            }
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.tags = that.$route.query.type;
            //let newTime = new Date();
            that.dataAjax();
            that.$utils.screenHeight();
        }) 
    },
    beforeDestroy() {
        clearInterval(this.setTimer);
    },
    watch: {
		$route(){
			let that = this;
            that.tags = that.$route.query.type;
            that.$refs.left.curType = that.tags;
            that.clearListData();
		},
	},
    methods: {
        //下拉选择
        dropDownChoose(name,type,num){
            let that = this;
            if(num===1){
                if(that.curMedia == '抖音'){
                    return 
                }
                that.curRankType = type;
                that.curRank = name;
            }else if(num===2){
                that.curMapName = that.provinceFullList[type]
                that.curProvMapName = that.curMapName;    
            }else if(num===4){
               
                that.curEmotion = type;
            }else{
                that.curMedia = name;
            }
            if(name==='抖音'){
                that.curRank = '昨日热点';
                that.curRankType = 2;
            }
            that.clearListData();
        },
        dataAjax(type){
            let that = this,tags='',province = '',city='',county='',emotion='';
            tags = (that.tags == '全部')?'':that.tags;
            that.$parent.loadModal(true,'数据加载中...');
            that.$axios.get('static/city.json').then((r) => {
                that.provinceList = r.data.shortProvince;
                that.provinceFullList = r.data.province;
            });
            if(that.curMapName!='全国'){
                province = that.curMapName
            }
            if(type==2 || type==5){
                province = that.curProvMapName
                city = that.curCityMapName
            }
            if(type==3 || type==4){
                province = that.curProvMapName
                city = that.curCityMapName
                county = that.curAreaMapName
            } 
            if(type==4 && city !=''){
                that.curMapName = city
            }
            //console.log(that.curMapName);
            let time = that.$utils.dateConversion(that.time,0)
            if(that.curEmotion!="全部"){
                emotion = that.curEmotion
            }
            if(county==''|| type==4){
                let datas={
                    type:that.curRankType,
                    tag:tags,
                    news_type:that.mediaList[that.curMedia],
                    province:province,
                    city:city,
                    date:time,
                    news_emotion:emotion,
                    api_secret:that.apiSecret
                };
                if(type==5 && county==''){
                    datas.city = ''
                    that.curMapName = province;
                }
                //热点事件地图
                that.$api.get('news/index/hot-list-map', datas, r => {
                    that.$parent.returnCode(r,function(){
                        let data = r.data;
                        that.mapChartData = data;
                        if(r.data.length<=0){
                            that.nodata.mapChartData = true;
                            return
                        }else{
                            that.nodata.mapChartData = false;
                        }
                    });
                })
             }
            let datas1={
                type:that.curRankType,
                news_type:that.mediaList[that.curMedia],
                tag:tags,
                date:time,
                province:province,
                city:city,
                county:county,
                perpage:that.pageNum,
                page:that.pageCur,
                news_emotion:emotion,
                api_secret:that.apiSecret
            };
            //热点事件
            that.$api.get('news/index/hot-list',datas1,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    that.hotAllRank = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata.hotAllRank = true;
                        return
                    }else{
                        that.nodata.hotAllRank = false;
                    }
                });
            });
        },
        //地图点击
        fatherMethod(name,id,type){
            let that = this;
            that.curMapName = name;
            if(type==2){ 
                that.curCityMapName = name;
                that.curFullName = that.curProvMapName +"-"+that.curCityMapName;
                that.dataAjax(type);
            }else if(type==3){
                that.curMapName=that.curProvMapName
                that.curAreaMapName = name;
                if(that.curCityMapName==''){
                    that.curFullName = that.curProvMapName +"-"+that.curAreaMapName;
                }else{
                    that.curFullName = that.curProvMapName +"-"+that.curCityMapName +"-"+that.curAreaMapName;
                }
                that.dataAjax(type);
            }else{
                that.curProvMapName = name;
                that.curFullName = that.curProvMapName
                that.dataAjax();
            }
            that.$refs.citySelect.fullName = that.curFullName;
            that.$refs.citySelect.clickCityMap(name,type)
        },
        // 地区筛选
        citySelect1 (name) {
            let province = name[0];
            let fullCity = name[1];
            let city = name[2];
            let county = name[4];
            let type = name[5];
            let that = this;
            that.curAreaMapName = (county === '全市'|| county === '选择区县')?'':county;
            that.curCityMapName = (fullCity === '全省'|| fullCity === '选择城市' || city === '全市')?'':fullCity;
            if(province === '全国'){
                that.curMapName = '全国';
                that.curProvMapName = ''
            }else{
                that.curMapName = province;
                that.curProvMapName = that.curMapName;
            }
            if(that.curAreaMapName!=''){
                if(type!=2){
                    that.curMapName = fullCity;
                }
                that.dataAjax(4);
            }else if(that.curCityMapName!=''){
                that.curMapName = fullCity;
                if(type==5){
                    that.dataAjax(type);
                }else{
                    that.dataAjax(2); 
                }
            }else{
                 that.dataAjax();
            }
        },
        changeTime(){
            let that = this;
            that.clearListData();
        },
        disabledDate (time) {
            return time > this.maxTime
            //return time < this.min || time > this.max
        },
        clearListData(){
            let that = this;
            that.hotAllRank = [];
            if(that.curAreaMapName!=''){
                that.dataAjax(4);
            }else if(that.curCityMapName!=''){
                that.dataAjax(2);
            }else{
                 that.dataAjax();
            }
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/event/eventN.vue